export default "__VITE_ASSET__BM03rT_M__"